export const sxStyle = {
  subTitlesText: {
    fontSize: '16px',
    color: '#000000',
    textAlign: 'center',
  },

  tableStyles: {
    mb: '20px',
    borderRadius: '8px',
    border: '4px solid #E5E5E5',
    height: { xs: 'auto' },
  },

  boxContainer: {
    width: '100%',
    height: '100%',
  },

  contentRowsColumns: {
    justifyContent: 'space-between',
    flexDirection: { xs: 'column', sm: 'row' },
  },

  bordersDownRight: {
    p: '8px',
    borderRight: { xs: 'none', sm: '4px solid #E5E5E5' },
    borderBottom: { xs: '4px solid #E5E5E5', sm: 'none' },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '8px',
    width: '100%',
    height: '100%',
    minHeight: '160px',
  },
  subTitles: {
    fontSize: '18px',
    fontWeight: 600,
    textAlign: 'center',
    color: '#000',
  },
};
